"use client";

import { dynamicChart } from "@/components/charts/dynamicChart";

export type { CouncilMinutesDistProps } from "./CouncilMinutesDistChart.impl";

export const CouncilMinutesDistChart = dynamicChart(
  () => import("./CouncilMinutesDistChart.impl").then((m) => m.CouncilMinutesDistChart),
  200,
);
